import load from './lazy-load'

export const Send = load(() =>
  import(/* webpackChunkName: "send-page" */ './components/homepage/send-page')
)
export const Request = load(() =>
  import(
    /* webpackChunkName: "request-page" */ './components/homepage/request-page'
  )
)
export const ContactList = load(() =>
  import(
    /* webpackChunkName: "contact-list" */ './components/contacts/contact-list'
  )
)

export const MiscFunnel = load(() =>
  import(
    /* webpackChunkName: "more-funnel" */ './components/homepage/more-funnel'
  )
)

export const Preview = load(() =>
  import(
    /* webpackChunkName: "universal-preview" */ './components/preview/preview'
  )
)

export const SendSuccess = load(() =>
  import(
    /* webpackChunkName: "send-success" */ './components/send-success-wrapper'
  )
)
export const BuySuccess = load(() =>
  import(
    // bundle it together with send success as they are mostly the same and often loaded together
    /* webpackChunkName: "send-success" */ './components/buy-success-wrapper'
  )
)

export const PayRequestSuccessRedux = load(() =>
  import(
    /* webpackChunkName: "pay-request-success" */ './components/pay-request-success'
  )
)
export const Recipient = load(() =>
  import(
    /* webpackChunkName: "recipient-redux" */ './components/recipient-redux'
  )
)

export const MGMLandingPage = load(() =>
  import(
    /* webpackChunkName: "mgm-landing" */ './components/mgm/mgmLandingPage'
  )
)

// Request flow
export const RequestSuccess = load(() =>
  import(
    /* webpackChunkName: "request-success" */ './components/requestSuccess'
  )
)

// bundle request preview in one file
export const MultiRequestSplitPreview = load(() =>
  import(
    /* webpackChunkName: "request-preview" */ './components/multi-split-request-preview'
  )
)

// Bill Splitting flow
export const BillSplitRequest = load(() =>
  import(
    // this is using the new request-base component, bundle them together
    /* webpackChunkName: "request-page" */ './components/homepage/request-page/request-layout-billsplit'
  )
)
export const MultiRecipient = load(() =>
  import(
    /* webpackChunkName: "multi-recipient-redux" */ './components/multi-recipient-redux'
  )
)

export const BillSplittingPreview = load(() =>
  import(
    /* webpackChunkName: "request-preview" */ './components/bill-splitting-preview'
  )
)
export const BillSplittingSuccess = load(() =>
  import(
    /* webpackChunkName: "request-success" */ './components/bill-splitting-success'
  )
)

export const FundingOptionSelector = load(() =>
  import(
    /* webpackChunkName: "funding-option-selector" */ './components/funding-option-selector'
  )
)

// Reveal flow
export const Reveal = load(() =>
  import(/* webpackChunkName: "reveal" */ './components/reveal')
)

export const Unilateral = load(() =>
  import(
    /* webpackChunkName: "unilateralMoneyClaimed" */ './components/unilateralMoneyClaimed'
  )
)

export const UnilateralClaimMoney = load(() =>
  import(
    /* webpackChunkName: "unilateral-claim-money" */ './components/unilateral-claim-money'
  )
)

// Guest flow, put all guest related stuff in one bundle for now
export const GuestLogin = load(() =>
  import(/* webpackChunkName: "guest" */ './containers/guest/guestLogin')
)
export const GuestHeader = load(() =>
  import(/* webpackChunkName: "guest" */ './components/guestHeader')
)

export const GuestPayRequestRecipientHeader = load(() =>
  import(
    /* webpackChunkName: "guest" */ './containers/guest/recipient-header-pay-request'
  )
)
export const GuestPayPalPoolsRecipientHeader = load(() =>
  import(
    /* webpackChunkName: "guest" */ './containers/guest/recipient-header-pools'
  )
)
export const GuestPayPalPoolsPreviewRecipientHeader = load(() =>
  import(
    /* webpackChunkName: "guest" */ './containers/guest/recipient-header-pools-preview'
  )
)
export const GuestCreateAccount = load(() =>
  import(
    /* webpackChunkName: "guest" */ './containers/guest/createAccount/createAccount'
  )
)
export const GuestPreview = load(() =>
  import(/* webpackChunkName: "guest" */ './containers/guest/preview')
)
export const GuestLoginSuccess = load(() =>
  import(/* webpackChunkName: "guest" */ './containers/guest/guestLoginSuccess')
)
export const SendSuccessHeader = load(() =>
  import(/* webpackChunkName: "guest" */ './containers/sendSuccessHeader')
)

export const EditContacts = load(() =>
  import(
    /* webpackChunkName: "edit-contacts" */ './components/edit-contacts-bot'
  )
)

export const SessionTimer = load(
  () =>
    import(
      /* webpackChunkName: "sessionTimer" */ 'react-components/sessionTimer'
    ),
  false
)

// other stuff
export const Overpanel = load(
  () =>
    import(/* webpackChunkName: "overpanel" */ 'react-components/overpanel'),
  false
)

export const DisabledMassPayment = load(() =>
  import(
    /* webpackChunkName: "disabled-mass-payment" */ './components/errors/disabled-mass-payment'
  )
)
export const MoneyClaimedError = load(() =>
  import(
    /* webpackChunkName: "moneyClaimedError" */ './components/moneyClaimedError'
  )
)

export const ErrorCommon = load(
  () =>
    import(/* webpackChunkName: "errorCommon" */ './components/errorCommon'),
  false
)
export const AddBillingAddressOverpanel = load(
  () =>
    import(
      /* webpackChunkName: "addBillingAddressOverpanel" */ './components/addBillingAddressOverpanel'
    ),
  false
)
export const AddShippingAddressOverpanel = load(
  () =>
    import(
      /* webpackChunkName: "addShippingAddressOverpanel" */ './components/addShippingAddressOverpanel'
    ),
  false
)
export const AddCardOverpanel = load(
  () =>
    import(
      /* webpackChunkName: "addCardOverpanel" */ './components/addCardOverpanel'
    ),
  false
)
export const C2AddCardOverpanel = load(
  () =>
    import(
      /* webpackChunkName: "c2AddCardOverpanel" */ './components/c2AddCardOverpanel'
    ),
  false
)
export const NotOverseasRecipient = load(
  () =>
    import(
      /* webpackChunkName: "not-overseas-recipient" */ './components/errors/not-overseas-recipient'
    ),
  false
)
export const BRRecipient = load(
  () =>
    import(
      /* webpackChunkName: "br-recipient" */ './components/errors/br-recipient'
    ),
  false
)
export const LATAMRecipient = load(
  () =>
    import(
      /* webpackChunkName: "latam-recipient" */ './components/errors/latam-recipient'
    ),
  false
)

export const AddCardMessenger = load(() =>
  import(
    /* webpackChunkName: "addCardMessenger" */ './containers/addCardMessenger'
  )
)

export const AboutCashAdvanceFees = load(() =>
  import(
    /* webpackChunkName: "aboutCashAdvanceFees" */ './components/cash-advance-fees-overpanel/cash-advance-fees-about'
  )
)

export const ReferralCheckList = load(() =>
  import(
    /* webpackChunkName: "ReferralChecklist" */ './components/mgm/referral-checklist'
  )
)

export const Chat = load(() =>
  import(/* webpackChunkName: "chatComponent" */ './components/chat')
)

export const BlockContactList = load(() =>
  import(
    /* webpackChunkName: "blockedContactList" */ './components/contacts/blocked-contacts'
  )
)

/**
 * FEAT. Guest flow revamp: Info Collection page with OB integration.
 */
export const GuestInfoCollection = load(() =>
  import(
    /* webpackChunkName: "guest" */ './containers/guest/createAccount/guestRevampInfoCollection'
  )
)

/**
 * FEAT. Guest flow revamp: Info Collection page with OB integration.
 */
export const GuestRevampPostPaySignup = load(() =>
  import(
    /* webpackChunkName: "guest" */ './containers/guest/createAccount/guestRevampPostPaySignup'
  )
)

/**
 * FEAT. Guest flow revamp: Info Collection page with OB integration.
 */
export const MgmPSErrorPage = load(() =>
  import(/* webpackChunkName: "guest" */ './components/errors/mgm-ps-error')
)

/**
 * ULP Claim Share: Landing page for educating reciever about their emails and allowing to resending them again.
 */
export const ULPClaimSharePage = load(() =>
  import(/* webpackChunkName: "guest" */ './components/unilateral-claim-share')
)

/**
 * Visa Plus Screens (Onboard, Profile, NextSteps)
 */
export const Onboard = load(() =>
  import(
    /* webpackChunkName: "VisaPlusOnboard" */ './components/visa-plus/onboard'
  )
)

export const Profile = load(() =>
  import(
    /* webpackChunkName: "VisaPlusProfile" */ './components/visa-plus/profile'
  )
)

export const NextSteps = load(() =>
  import(
    /* webpackChunkName: "VisaPlusNextSteps" */ './components/visa-plus/nextsteps'
  )
)

export const ConfirmPhone = load(() =>
  import(
    /* webpackChunkName: "VisaPlusConfirmPhone" */ './components/visa-plus/confirmPhone'
  )
)

export const SendToApp = load(() =>
  import(
    /* webpackChunkName: "VisaPlusSendToApp" */ './components/visa-plus/sendToApp'
  )
)
